import { useQuery } from '@tanstack/react-query'
import { newsletterApi } from '@/api/newsletter'

export function useNewsletterSubscribers(activeOnly = true) {
  return useQuery({
    queryKey: ['newsletter', 'subscribers', activeOnly],
    queryFn: () => newsletterApi.list(activeOnly),
  })
}
